import Card from 'react-bootstrap/Card';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import { useSearchParams } from "react-router-dom";

export function CorgEntity(props) {
  const [, setSearchParams] = useSearchParams();

  const setSearchTerm = (search) => {
    if (!search) return;
    setSearchParams((prev) => {
      prev.set("dealerId", search);
			prev.delete("e"); 
			prev.delete("va");
			prev.delete("iol");
			prev.delete("ddc");
			prev.delete("vs");
			prev.delete("atc");
      return prev;
    }, { replace: true });
    props.setShowLookup(false);
  };

  return <Card>
    <Card.Header><b>{props.obj.legalName}</b></Card.Header>
    <Card.Body>
      <Table className="oem-result">
        <tbody>
          <tr>
            <th>Address</th>
            <td>{props.obj.address.street} {props.obj.address.city} {props.obj.address.state} {props.obj.address.zip}</td>
          </tr>
          <tr>
            <th>Common Org ID</th>
            <td>
              <Button variant="link" onClick={() => setSearchTerm(props.obj.commonOrgId)}>
                {props.obj.commonOrgId}
              </Button>
            </td>
          </tr>
        </tbody>
      </Table>
    </Card.Body>
  </Card>;
}